var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileeye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.333,
    height: 16,
    viewBox: "0 0 21.333 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "view",
    transform: "translate(0 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10203",
    "data-name": "Path 10203",
    d: "M21.252,10.628C19.5,6.832,15.556,3,10.667,3S1.828,6.832.081,10.628a.9.9,0,0,0,0,.743C1.828,15.168,5.778,19,10.667,19s8.838-3.832,10.586-7.628A.9.9,0,0,0,21.252,10.628ZM10.667,17.222c-3.921,0-7.241-3.157-8.791-6.222,1.55-3.065,4.87-6.222,8.791-6.222S17.908,7.935,19.458,11c-1.55,3.065-4.87,6.222-8.791,6.222Z",
    transform: "translate(0)",
    fill: "#b07f4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10204",
    "data-name": "Path 10204",
    d: "M11.444,7a4.444,4.444,0,1,0,4.444,4.444A4.444,4.444,0,0,0,11.444,7Zm0,7.111a2.667,2.667,0,1,1,2.667-2.667A2.667,2.667,0,0,1,11.444,14.111Z",
    transform: "translate(-0.778 -0.444)",
    fill: "#b07f4a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileeye);
export default __webpack_public_path__ + "static/media/profileeye.323c7aadf8aa018340a073ea5305ab3d.svg";
export { ForwardRef as ReactComponent };